import { css } from '@emotion/react';
import { theme } from 'global';

export const container = css`
  background-color: #ede6ff;
  padding: 24px 32px;
  min-height: 325px;

  @media screen and (max-width: ${theme.breaks.xs}px) {
    padding: 24px 20px;
  }
`;

export const heading = css`
  color: #1a0826 !important;
  @media screen and (max-width: ${theme.breaks.xs}px) {
    font-size: 18px;
    font-weight: 500;
    line-height: 32px;
    letter-spacing: 0.2px;
  }
`;

export const subHeading = css`
  margin-top: 10px;
`;

export const input = css`
  display: flex;
  align-items: center;
  margin: 29px 0 24px 0;

  @media screen and (max-width: ${theme.breaks.xs}px) {
    margin: 12px 0 24px 0;
  }
`;

export const linkStyle = css`
  font-family: Sharp Grotesk;
  font-size: 14px;
  font-weight: 500;
  @media screen and (max-width: ${theme.breaks.xs}px) {
    text-align: center;
  }
`;
